module.exports = __webpack_public_path__ + "static/media/mail.f9c3198a.svg";